import { ProblemResponse } from '../utils/authApi';

export interface ILoginInput {
  email: string;
  password: string;
}

export enum LoginStep {
  NotLoggedIn = 'NOT_LOGGED_IN',
  ChangePassword = 'CHANGE_PASSWORD',
  MfaSetup = 'MFA_SETUP',
  MfaVerify = 'MFA_VERIFY',
  ForgotPassword = 'FORGOT_PASSWORD',
  ConfirmForgotPassword = 'CONFIRM_FORGOT_PASSWORD',
}

export enum ICognitoChallenge {
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  MfaSetup = 'MFA_SETUP',
  MfaRequired = 'SOFTWARE_TOKEN_MFA',
}

export interface ICognitoResponse extends ProblemResponse {
  challenge?: ICognitoChallenge;
}
